import { useCallback } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Button, IconButton, Popover, PopoverProps, Typography } from '@mui/material';

import Stack from '@/components/Stack';

interface Props {
  title?: string;
  minWidth?: number;
  onClose?: (applyChanges: boolean) => void;
}

type FilterPopperProps = Props & Pick<PopoverProps, 'open' | 'children' | 'anchorEl'>;

const FilterPopper = ({
  title,
  open,
  onClose,
  children,
  minWidth,
  anchorEl,
}: FilterPopperProps) => {
  const handleClickCloseButton = useCallback(() => onClose?.(false), [onClose]);
  const handleClickApplyButton = useCallback(() => onClose?.(true), [onClose]);
  const handleClosePopover = useCallback(() => onClose?.(false), [onClose]);

  return (
    <Popover
      open={open}
      onClose={handleClosePopover}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      elevation={1}
      BackdropProps={{
        invisible: true,
        // @ts-expect-error BackdropProps inaccurately contains only MUI-defined props.
        'data-testid': 'backdrop',
      }}
      slotProps={{
        root: { sx: { mt: 1, zIndex: 'modal' } },
        paper: { sx: { p: 2 } },
      }}
    >
      <Stack direction="column" spacing={3} minWidth={minWidth}>
        <Stack direction="row" gap={1} alignItems="center" justifyContent="space-between">
          <Typography variant="body2" fontWeight="bold">
            {title}
          </Typography>
          <IconButton size="small" data-testid="close" onClick={handleClickCloseButton}>
            <CloseIcon />
          </IconButton>
        </Stack>
        {children}
        <Button sx={{ alignSelf: 'flex-end' }} onClick={handleClickApplyButton}>
          Apply
        </Button>
      </Stack>
    </Popover>
  );
};

export { FilterPopperProps };
export default FilterPopper;
